export default function alarma() {
  return 0
}

export function getAlarmas(state) {
  return state.alarmas
}
